export function reduzirNome(nomeCompleto) {
  if (!nomeCompleto) return nomeCompleto;

  const partes = nomeCompleto.trim().split(/\s+/);
  if (partes.length === 0) return "";

  const excecoes = ["da", "em", "com", "de", "do", "das", "dos", "e", "-", "/", ","];

  // Função para capitalizar, exceto exceções
  const capitalizar = (palavra) => {
    const lower = palavra.toLowerCase();
    return excecoes.includes(lower)
      ? lower
      : lower.charAt(0).toUpperCase() + lower.slice(1);
  };

  const partesFormatadas = partes.map(capitalizar);

  if (partes.length >= 3 && excecoes.includes(partes[1].toLowerCase())) {
    return `${partesFormatadas[0]} ${partesFormatadas[1]} ${partesFormatadas[2]}`;
  } else if (partes.length >= 2) {
    return `${partesFormatadas[0]} ${partesFormatadas[1]}`;
  } else {
    return partesFormatadas[0];
  }
}

export function capitalizeNome(nomeCompleto) {
  if (!nomeCompleto) return nomeCompleto;

  const partes = nomeCompleto.trim().split(/\s+/);
  if (partes.length === 0) return "";

  const excecoes = ["da", "em", "com", "de", "do", "das", "dos", "e", "-", "/", ","];

  // Função para capitalizar, exceto exceções
  const capitalizar = (palavra) => {
    const lower = palavra.toLowerCase();
    return excecoes.includes(lower)
      ? lower
      : lower.charAt(0).toUpperCase() + lower.slice(1);
  };

  const partesFormatadas = partes.map(capitalizar);

    return partesFormatadas?.toString().replaceAll(',', ' ');

}

export function reduzirNomeUnico(nomes) {
  const nomeFormatado = nomes.map((nome) => {
    const partes = nome.trim().split(" ");
    return {
      original: nome,
      primeiro: partes[0],
      sobrenome: partes[1] || "",
    };
  });

  const contagem = nomeFormatado.reduce((acc, { primeiro }) => {
    acc[primeiro] = (acc[primeiro] || 0) + 1;
    return acc;
  }, {});

  return nomeFormatado.map(({ primeiro, sobrenome, original }) => {
    return contagem[primeiro] > 1 ? `${primeiro} ${sobrenome}` : primeiro;
  });
}